export default [
  {
    id: 1,
    title: "Experience",
    description: `I am a full stack developer who works on latest technologies, a keen learner and have worked with startups as well.
      Apart from being a developer, I am also a Mentor and Teaching Assistant at Udemy.`,
    path: "/experience",
  },
  {
    id: 2,
    title: "Projects",
    description: `I have worked on several projects (including confidential).
      Some of my projects can be seen on my Github Repository.`,
    path: "/projects",
  },
  {
    id: 3,
    title: "Recommendations",
    description: `What others say about me`,
    path: "/recommendation",
  },
]
